import { withTranslation } from "next-i18next";
import { useUserHasInternalTools } from "@hooks/use-current-user";
import { usePrice } from "@hooks/use-prices";
import Button from "@components/core/Button";
import ProductGlobalRating from "../Shared/ProductGlobalRating";
import ProductLike from "../Shared/ProductLike";
import catalogContexts from "@utils/constants/catalogContexts";

function ProductTitle({ product, context, openCompleteReviews, t }) {
  const userHasInternalTools = useUserHasInternalTools();
  const price = usePrice();

  return (
    <div className="pb-4 mb-2">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <button
          className="btn-transparent"
          onClick={() => openCompleteReviews()}
          disabled={!product.recent_comments.length}
        >
          <ProductGlobalRating
            globalRating={product.global_rating}
            ratingsCount={product.ratings_count}
            size="16px"
            className="gap-2"
          />
        </button>

        <ProductLike product={product} />
      </div>

      {userHasInternalTools ? (
        <div>
          <a
            href={`${process.env.NEXT_PUBLIC_FACTORY_BASE_PATH}/supply/products/${product.uid}`}
            target="_blank"
            rel="noopener noreferrer"
            className="h3 mb-2 text-dark me-3"
          >
            {product.name}
          </a>

          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => navigator.clipboard.writeText(product.uid)}
            hugContent
          >
            {`UID: ${product.uid}`}
          </Button>
        </div>
      ) : (
        <h3 className="mb-2">{product.name}</h3>
      )}

      <p className="mb-2">{product.brand.name}</p>

      {context === catalogContexts.sales ? (
        <p className="mb-0">
          <span className="h5">{price(product.current_price, { withoutSpace: true })}</span>
          <span className="text-gray">&nbsp;|&nbsp;</span>
          <span className="text-gray text-decoration-line-through">
            {price(product.retail_price)}
          </span>
        </p>
      ) : (
        <p className="mb-0 text-gray">
          {t("product:retail_price", {
            price: price(product.retail_price, { withoutSpace: true }),
          })}
        </p>
      )}
    </div>
  );
}

export default withTranslation("product")(ProductTitle);
